// Where the sign-up verification link lands. /dashboard (not /) so a newly verified user goes
// straight into onboarding instead of the marketing homepage. Shared by signUp and the
// "Resend verification email" action so both links behave identically.
// Must be on the Supabase Auth redirect allowlist (Dashboard → Authentication → URL Configuration).
export function getEmailConfirmRedirectUrl(): string {
  return `${window.location.origin}/dashboard`;
}
